import { useRef } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { IClient } from 'shared/models/Client'
import { setClientById } from 'shared/store/clients/actions'
import { useAppDispatch } from 'shared/store/store'

const CLIENT_ID_PARAMS = 'clientId'

const useCheckParamsForClient = () => {
  const locationRef = useRef<string>(window.location.pathname)
  const dispatch = useAppDispatch()
  const { search } = useLocation()
  const { replace } = useHistory()

  const params = new URLSearchParams(search)

  locationRef.current = window.location.pathname

  const _deleteClientIdParam = () => {
    params.delete(CLIENT_ID_PARAMS)
    replace({ search: params.toString() })
  }

  // We should not handle fault client we are on oldPortalUrls
  const ignoreOldPortalUrls = () => {
    const ಠ_ಠ = ['styrearbeid/signeringer']

    if (ಠ_ಠ.some((url) => locationRef.current.startsWith(`/portal/${url}`))) {
      console.log(
        'ClientId i url:',
        'ignorerte å bytte klient - lenken er mot gamle portal 👻'
      )

      return true
    }

    return false
  }

  const redirectIfFaultyClient = (client?: IClient) => {
    if (ignoreOldPortalUrls()) return

    const clientId = params.get(CLIENT_ID_PARAMS)

    if (!clientId) return

    if (client?.id === clientId) {
      _deleteClientIdParam()
      return
    }

    console.log('ClientId i url:', 'Byter klient 🌝')

    dispatch(setClientById(clientId))

    _deleteClientIdParam()
  }

  return redirectIfFaultyClient
}

export default useCheckParamsForClient
